import { CustomerTemplate } from "@/components/CustomerTemplateManager";

// 정산서 items → 배송정보 상품명 합성 규칙의 단일 소스.
// ShippingModalManager(모달 자동 채움)·useShippingSnapshotNudge(stale 비교/원클릭 반영)·
// 배송엑셀 stale 일괄 반영(분류/합성)이 공유. 규칙이 갈라지면 stale 오탐이 생기므로 복제 금지.

// 합성 구분자 — 상품명 자체에 이 문자열이 포함될 수 있으므로(분류 로직의 순열 비교 가드 근거)
// 문자열 분해로 항목 경계를 복원하려 하지 말 것.
export const PRODUCT_LIST_SEPARATOR = ', ';

// 항목 1개 → 토큰 1개. 이름이 비면 '' (합성에서 제외됨).
export type SettlementItemLike = { name?: string | null; quantity?: number | string | null };

export const formatSettlementItemToken = (item: SettlementItemLike): string => {
  const name = item?.name?.trim();
  if (!name) return '';
  const qty = Number(item?.quantity) || 0;
  return qty > 1 ? `${name} x${qty}` : name;
};

// items 배열 시그니처 코어 — CustomerTemplate 없이도(order_item 유래 데이터) 재사용.
export const buildProductListFromItems = (items: SettlementItemLike[] | null | undefined): string =>
  (items || [])
    .map(formatSettlementItemToken)
    .filter((s) => s.length > 0)
    .join(PRODUCT_LIST_SEPARATOR);

// 기존 소비자용 얇은 래퍼 (동작 동등 — 기존 body를 코어로 이동만 함).
const buildProductListFromSettlement = (customer: CustomerTemplate): string =>
  buildProductListFromItems(customer.items);

export { buildProductListFromSettlement };
